import React, { useRef, useEffect } from 'react';
import { useIsVisible } from '@/hooks/useIsVisible';

import { TypeSocialProofVideoItemFields } from '@/core/generated-types';
import { Card } from '../../SocialProof';
import { isMuxVideo } from '@/components/common/LandingPageHero/utils';
import { MuxVideo } from '@/components/ui/MuxVideo';
import { TypeMuxVideoFields } from '@/core/generated-types';

const MuxVideoItem = ({
  media,
  breakAfter,
}: TypeSocialProofVideoItemFields) => {
  if (!media) return null;
  const playbackId =
    media && (media.fields as TypeMuxVideoFields)?.muxVideoUpload?.playbackId;

  const props = {
    title: media.fields.entryName || '',
    playbackId,
    autoplay: true,
    controls: true,
  };
  return (
    <Card classes={breakAfter ? 'break-after-column' : ''}>
      <div className="aspect-w-9 aspect-h-16 rounded-lg overflow-hidden">
        <MuxVideo {...props} />
      </div>
    </Card>
  );
};

const Video = ({ asset }: TypeSocialProofVideoItemFields) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const isVisible = useIsVisible(videoRef);

  useEffect(() => {
    if (!videoRef.current) return;

    if (isVisible) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  }, [isVisible]);

  if (!asset) return null;

  return (
    <Card>
      <video
        ref={videoRef}
        width="w-full"
        className="rounded-lg"
        height="400"
        controls
        playsInline // to play video on iOS
        autoPlay
        muted
        loop
      >
        <source src={asset.fields.file?.url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </Card>
  );
};

const VideoItem = ({
  entryName,
  asset,
  media,
  breakAfter,
}: TypeSocialProofVideoItemFields) => {
  return (
    <>
      {media && isMuxVideo(media) ? (
        <MuxVideoItem
          entryName={entryName}
          media={media}
          breakAfter={breakAfter}
        />
      ) : (
        <Video entryName={entryName} asset={asset} />
      )}
    </>
  );
};

export default VideoItem;
